<template>
	<div>
		<div class="main-filter">
			<el-form inline :model="formInline" class="demo-form-inline">
				<el-form-item label="车牌号：" v-if="checkTab == 1">
					<el-autocomplete
						v-model.trim="formInline.licenseNumber"
						:fetch-suggestions="querySearchAsync"
						clearable
						placeholder="请输入内容"
					></el-autocomplete>
				</el-form-item>
				<el-form-item label="设备名称：" v-else>
					<el-autocomplete v-model.trim="formInline.name" :fetch-suggestions="querySearchAsync" clearable placeholder="请输入内容"></el-autocomplete>
				</el-form-item>
				<el-form-item label="省：">
					<el-select v-model="formInline.economize" placeholder="请选择省" @change="changeEconomize($event, 1)">
						<el-option v-for="item in economizeList" :key="item.id" :label="item.title" :value="item.code"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="市：">
					<el-select v-model="formInline.market" placeholder="请选择市" @change="changeEconomize($event, 2)">
						<el-option v-for="item in marketList" :key="item.id" :label="item.title" :value="item.code"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="区县：">
					<el-select v-model="formInline.district" placeholder="请选择区县" @change="changeEconomize($event, 3)">
						<el-option v-for="item in districtList" :key="item.id" :label="item.title" :value="item.code"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="乡镇：">
					<el-select v-model="formInline.regionCode" placeholder="请选择">
						<el-option v-for="item in townList" :key="item.id" :label="item.title" :value="item.code"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="车型：" v-if="checkTab == 1">
					<el-select v-model="formInline.modelDictionaryItemId" placeholder="请选择">
						<el-option v-for="item in carTypeList" :key="item.id" :label="item.title" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="设备类型：" v-else>
					<el-select v-model="formInline.deviceType" placeholder="请选择">
						<el-option v-for="item in deviceTypeList" :key="item.id" :label="item.title" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="onSearch" icon="el-icon-search">搜索</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div class="main-content">
			<div class="tabClass">
				<span :class="{ activeClass: checkTab === 1 }" @click="changeCheckTab(1)">车辆统计</span>
				<span :class="{ activeClass: checkTab === 2 }" @click="changeCheckTab(2)">设备统计</span>
			</div>
			<div class="main-content-title">
				<p>共有 {{ total }} 条结果</p>
			</div>
			<Table
				:loading="loading"
				:table-data="tableData"
				:total="total"
				:table-head="checkTab == 1 ? tableHead : tableHeadDevice"
				:current-page.sync="queryData.current"
				:page-size.sync="queryData.size"
				:operation-column-width="100"
				:is-show-selection="false"
				:showOperation="false"
				@change-page="getList"
				:tableHeight="tableHeight"
			>
				<template #account="{ scope }">
					<el-button @click="accountInfoHand(scope.row)" size="mini" type="text"> 账号信息 </el-button>
				</template>
			</Table>
		</div>
		<AccountInfo ref="accountInfo" :isShowDetail="true"></AccountInfo>
	</div>
</template>

<script>
export default {
	name: 'resourceStatic',
	components: {
		Table: () => import('@/components/Table/table'),
		AccountInfo: () => import('@/views/accountManager/countyAccount/newDialog'),
	},
	data() {
		return {
			formInline: {
				name: '',
				licenseNumber: '',
				economize: '',
				market: '',
				district: '',
				regionCode: '',
				modelDictionaryItemId: '',
				deviceType: null,
			},
			checkTab: 1,
			tableHead: [
				{
					label: '车牌号',
					prop: 'licenseNumber',
					formatter: (row) => {
						return row.licenseNumber || '-';
					},
				},
				{
					label: '车型',
					prop: 'modelDictionaryItem',
					formatter: (row) => {
						return row.modelDictionaryItem?.title || '-';
					},
				},
				{
					label: '性质',
					prop: 'characterDictionaryItem',
					formatter: (row) => {
						return row.characterDictionaryItem?.title || '-';
					},
				},
				{
					label: '用途',
					prop: 'usageDictionaryItem',
					formatter: (row) => {
						return row.usageDictionaryItem?.title || '-';
					},
				},
				{
					label: '载人数',
					prop: 'carryingCapacity',
					formatter: (row) => {
						return row.carryingCapacity || '-';
					},
				},
				{
					label: '所属单位',
					prop: 'ownerOrganizationName',
					formatter: (row) => {
						return row.ownerOrganizationName || '-';
					},
				},
				{
					label: '负责人',
					prop: 'principalName',
					formatter: (row) => {
						return row.principalName || '-';
					},
				},
				{
					label: '联系电话',
					prop: 'phoneNumber',
					formatter: (row) => {
						return row.phoneNumber || '-';
					},
				},
				{
					label: '车辆状态',
					prop: 'state',
					formatter: (row) => {
						return row.state === 'I' ? '闲置' : row.state === 'U' ? '使用中' : '-';
					},
				},
				{
					label: '所属账号',
					prop: 'account',
				},
			],
			tableHeadDevice: [
				{
					label: '设备名称',
					prop: 'name',
					formatter: (row) => {
						return row.name || '-';
					},
				},
				{
					label: '设备类型',
					prop: 'modelDictionaryItem',
					formatter: (row) => {
						return row.modelDictionaryItem?.title || '-';
					},
				},
				{
					label: '性质',
					prop: 'characterDictionaryItem',
					formatter: (row) => {
						return row.characterDictionaryItem?.title || '-';
					},
				},
				{
					label: '用途',
					prop: 'usageDictionaryItem',
					formatter: (row) => {
						return row.usageDictionaryItem?.title || '-';
					},
				},

				{
					label: '所属单位',
					prop: 'ownerOrganizationName',
					formatter: (row) => {
						return row.ownerOrganizationName || '-';
					},
				},
				{
					label: '负责人',
					prop: 'principalName',
					formatter: (row) => {
						return row.principalName || '-';
					},
				},
				{
					label: '联系电话',
					prop: 'phoneNumber',
					formatter: (row) => {
						return row.phoneNumber || '-';
					},
				},
				{
					label: '设备状态',
					prop: 'state',
					formatter: (row) => {
						return row.state === 'I' ? '闲置' : row.state === 'U' ? '使用中' : '-';
					},
				},
				{
					label: '所属账号',
					prop: 'account',
				},
			],
			loading: false,
			queryData: {
				current: 1,
				size: 10,
			},
			total: 0,
			tableData: [],
			districtList: [], //区县
			marketList: [], //市
			townList: [],
			economizeList: [], //省
			options: [],
			carTypeList: [],
			deviceTypeList: [],
		};
	},
	computed: {
		tableHeight() {
			return window.innerHeight - 300;
		},
	},
	watch: {
		checkTab: {
			handler(val) {
				if (val == 1) {
					this.getInstitList();
				} else {
					this.getInstitDevciesList();
				}
				this.getList();
			},
			deep: true,
		},
	},
	mounted() {
		if (this.checkTab == 1) {
			this.getInstitList();
		} else {
			this.getInstitDevciesList();
		}
		this.getEconomizeList();
		this.getList();
	},
	methods: {
		// 获取车辆list
		getInstitList() {
			this.$http
				.get(this.api.getDictionaryItems + '.json', { params: { dictionaryCode: 'MOTORCYCLE_TYPE' } })
				.then((res) => {
					if (res.data && res.data.success) {
						this.carTypeList = res.data.collection || [];
						this.carTypeList.unshift({
							id: null,
							title: '全部',
						});
					}
				})
				.catch((e) => {});
		},
		// 获取设备list
		getInstitDevciesList() {
			this.$http
				.get(this.api.getDictionaryItems + '.json', { params: { dictionaryCode: 'EQUIPMENT_TYPE' } })
				.then((res) => {
					if (res.data && res.data.success) {
						this.deviceTypeList = res.data.collection || [];
						this.deviceTypeList.unshift({
							id: null,
							title: '全部',
						});
					}
				})
				.catch((e) => {});
		},
		// 获取省数据
		getEconomizeList() {
			this.$http
				.get(this.api.getChinaRegions)
				.then((res) => {
					if (res.data && res.data.success) {
						this.economizeList = res.data.collection || [];
						this.economizeList.unshift({
							title: '全部',
							code: '',
						});
					}
				})
				.catch((e) => {});
		},
		// 获取市/区县
		changeEconomize(data, type) {
			switch (type) {
				case 1:
					this.formInline.market = null;
					this.formInline.district = null;
					this.formInline.regionCode = null;
					this.marketList = [];
					this.districtList = [];
					this.townList = [];
					if (!data || data == '') return;
					this.$http
						.get(this.api.getChinaRegions, { params: { code: data } })
						.then((res) => {
							if (res.data && res.data.success) {
								this.marketList = res.data.collection || [];
								this.marketList.unshift({
									title: '全部',
									code: '',
								});
							}
						})
						.catch((e) => {});
					break;
				case 2:
					this.formInline.district = null;
					this.formInline.regionCode = null;
					this.districtList = [];
					this.townList = [];
					if (!data || data == '') return;
					this.$http
						.get(this.api.getChinaRegions, { params: { code: data } })
						.then((res) => {
							if (res.data && res.data.success) {
								this.districtList = res.data.collection || [];
								this.districtList.unshift({
									title: '全部',
									code: '',
								});
							}
						})
						.catch((e) => {});
					break;
				case 3:
					this.formInline.regionCode = null;
					this.townList = [];
					if (!data || data == '') return;
					this.$http
						.get(this.api.getChinaRegions, { params: { code: data } })
						.then((res) => {
							if (res.data && res.data.success) {
								this.townList = res.data.collection || [];
								this.townList.unshift({
									title: '全部',
									code: '',
								});
							}
						})
						.catch((e) => {});
					break;
				default:
					break;
			}
		},
		// 查询条件
		onSearch() {
			this.queryData.current = 1;
			this.getList('');
		},
		changeCheckTab(val) {
			this.checkTab = val;
			this.queryData.current = 1;
			this.getList('');
		},
		// 搜索建议
		querySearchAsync(queryString, cb) {
			queryString ? this.getList('filter') : '';
			clearTimeout(this.timeout);
			this.timeout = setTimeout(() => {
				cb(this.options);
			}, 1000 * Math.random());
		},
		//获取列表
		getList(type = '') {
			type == 'filter' ? '' : (this.loading = true);
			const { licenseNumber, name, economize, market, district, regionCode, modelDictionaryItemId, deviceType } = this.formInline;
			let code =
				economize && !market && !district && !regionCode
					? economize
					: economize && market && !district && !regionCode
					? market
					: economize && market && district && !regionCode
					? district
					: economize && market && district && regionCode
					? regionCode
					: null;
			let data = {
				licenseNumber: licenseNumber,
				name,
				regionCode: code,
				modelDictionaryItemId: this.checkTab == 1 ? modelDictionaryItemId : deviceType,
				...this.queryData,
			};
			let url = this.checkTab == 1 ? this.api.getVehicles : this.api.getDevices;
			this.$http
				.get(url + '.json', { params: data })
				.then((res) => {
					if (res.data && res.data.success) {
						if (type == 'filter') {
							this.options = res.data.collection.map((item) => {
								return {
									...item,
									value: this.checkTab == 1 ? item.licenseNumber : item.name,
								};
							});
						} else {
							this.tableData = res.data.collection || [];
							this.total = res.data.pagination.totalItems || 0;
							this.loading = false;
						}
					}
				})
				.catch((e) => {
					this.loading = false;
				});
		},
		accountInfoHand(row) {
			if (row.regionAccount?.id) {
				let data = {
					...row.regionAccount,
					chinaRegionDtoList: row.regions,
				};
				this.$refs.accountInfo.init(data);
			}
		},
	},
	created() {},
};
</script>

<style lang="scss" scoped>
.demo-form-inline {
	/deep/ .el-select {
		width: 120px !important;
		.el-input {
			width: 120px !important;
			.el-input__inner {
				width: 120px !important;
			}
		}
	}
	/deep/ .el-input {
		width: 160px;
	}
}
.main-content {
	.tabClass {
		width: calc(100% + 32px);
		line-height: 48px;
		border-bottom: 1px solid rgba($color: #000, $alpha: 0.1);
		margin-left: -16px;
		padding: 0 16px;
		span {
			display: inline-block;
			line-height: 48px;
			margin-right: 32px;
			font-size: 16px;
			cursor: pointer;
			color: #999999;
			&:hover {
				color: #1db9b1;
				border-bottom: 2px solid #1db9b1;
			}
		}
		.activeClass {
			color: #1db9b1;
			border-bottom: 2px solid #1db9b1;
		}
	}
	&-title {
		line-height: 48px;
		display: flex;
		justify-content: space-between;
		.el-button {
			line-height: 32px;
			padding: 0 16px;
			height: 32px;
			margin-top: 8px;
		}
	}
}
</style>